import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useEffect, useRef, useState } from 'react';
export var DragAndDrop = /*#__PURE__*/memo(function (_ref) {
  var children = _ref.children,
    prepareFiles = _ref.prepareFiles,
    setDragging = _ref.setDragging;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    dragCounter = _useState2[0],
    setDragCounter = _useState2[1];
  var dropRef = useRef(null);
  useEffect(function () {
    var preventingDefaultEvent = function preventingDefaultEvent(e) {
      e.preventDefault();
      e.stopPropagation();
    };
    var handleDragIn = function handleDragIn(e) {
      var _e$dataTransfer, _e$dataTransfer$items;
      preventingDefaultEvent(e);
      setDragCounter(function (prev) {
        return prev + 1;
      });
      if (((_e$dataTransfer = e.dataTransfer) === null || _e$dataTransfer === void 0 ? void 0 : (_e$dataTransfer$items = _e$dataTransfer.items) === null || _e$dataTransfer$items === void 0 ? void 0 : _e$dataTransfer$items.length) > 0) {
        setDragging(true);
      }
    };
    var handleDragOut = function handleDragOut(e) {
      preventingDefaultEvent(e);
      setDragCounter(function (prev) {
        return prev - 1;
      });
      if (dragCounter === 1) {
        setDragging(false);
      }
    };
    var handleDrop = function handleDrop(e) {
      var _e$dataTransfer2, _e$dataTransfer2$file;
      preventingDefaultEvent(e);
      setDragging(false);
      if (((_e$dataTransfer2 = e.dataTransfer) === null || _e$dataTransfer2 === void 0 ? void 0 : (_e$dataTransfer2$file = _e$dataTransfer2.files) === null || _e$dataTransfer2$file === void 0 ? void 0 : _e$dataTransfer2$file.length) > 0) {
        prepareFiles(e.dataTransfer.files);
        setDragCounter(0);
      }
    };
    var dndContainer = dropRef.current;
    if (dndContainer) {
      dndContainer.addEventListener('dragenter', handleDragIn);
      dndContainer.addEventListener('dragleave', handleDragOut);
      dndContainer.addEventListener('dragover', preventingDefaultEvent);
      dndContainer.addEventListener('drop', handleDrop);
    }
    return function () {
      if (dndContainer) {
        dndContainer.removeEventListener('dragenter', handleDragIn);
        dndContainer.removeEventListener('dragleave', handleDragOut);
        dndContainer.removeEventListener('dragover', preventingDefaultEvent);
        dndContainer.removeEventListener('drop', handleDrop);
      }
    };
  }, [dragCounter]);
  return /*#__PURE__*/React.createElement("div", {
    ref: dropRef,
    "data-t-id": "components-DragAndDrop"
  }, children);
});